import HKScan from './HKScan'

export default HKScan